module.exports = __webpack_public_path__ + "static/media/ionicons.24712f6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/ionicons.ttf?v=2.0.0
// module id = 1837
// module chunks = 0